const MASK_CHARACTERS = new Set(['*', '•', '●', '·', '◦', '▪', '▫', '○', '.', '…']);

function isMasked(value) {
  return Array.from(value).every((char) => MASK_CHARACTERS.has(char));
}

/**
 * Value to send for a secret field, or null when the stored secret must be kept.
 *
 * `editing` is the deliberate intent to replace the secret. Without it nothing is
 * sent, so neither a browser autofill nor a leftover form value can overwrite a
 * working credential during an unrelated update.
 */
export function secretFieldToSubmit(rawValue, { editing } = {}) {
  if (!editing) {
    return null;
  }
  const value = (rawValue || '').trim();
  if (!value || isMasked(value)) {
    return null;
  }
  return value;
}

export default secretFieldToSubmit;
